import React, { useState, useCallback } from 'react';
import Tippy from 'utils/Tippy';

import { Logs } from 'modules/log';

const LogsTooltipContent = ({ itineraryId, journeyId, shipperOrderId }) => {
  return (
    <Logs
      itineraryId={itineraryId}
      journeyId={journeyId}
      shipperOrderId={shipperOrderId}
      showAddLog={false}
      shipperOrdersSkin={{}}
      flex="3"
    />
  );
};

const LogsTooltip = ({ className, itinerary, children }) => {
  const [mounted, setMounted] = useState(false);
  const itineraryId = itinerary?.id;
  const journeyId = itinerary?.journey_id;
  const shipperOrderId = (itinerary?.shipper_order_ids || [])[0];

  const getContent = useCallback(() => {
    return (
      <LogsTooltipContent
        itineraryId={itineraryId}
        journeyId={journeyId}
        shipperOrderId={!journeyId && shipperOrderId}
      />
    );
  }, [journeyId, shipperOrderId, itineraryId]);

  const handleShow = useCallback(() => {
    setMounted(true);
  }, []);

  const handleHidden = useCallback(() => {
    setMounted(false);
  }, []);

  return (
    <>
      <Tippy
        placement="bottom"
        interactive={true}
        offset={[0, 0]}
        trigger="click"
        interactiveBorder={5}
        interactiveDebounce={50}
        appendTo={document.body}
        content={mounted && getContent()}
        maxWidth={'none'}
        theme="light"
        className={className}
        onShow={handleShow}
        onHidden={handleHidden}
      >
        {children}
      </Tippy>
    </>
  );
};

export default LogsTooltip;
